'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _prep = require('./internal/prep');

var _prep2 = _interopRequireDefault(_prep);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _prep2.default)({
    name: 'identity',
    all: function all() {
        return function (ii) {
            return ii;
        };
    }
});


//////////////////
// WEBPACK FOOTER
// ./~/unmutable/lib/identity.js
// module id = 267
// module chunks = 35783957827783